const sizeHandles = {
    "65A": "/collections/bh-storrelse-65a",
    "70A": "/collections/bh-storrelse-70a",
    "75A": "/collections/bh-storrelse-75a",
    "80A": "/collections/bh-storrelse-80a",
    "85A": "/collections/bh-storrelse-85a",
    "90A": "/collections/bh-storrelse-90a",
    "95A": "/collections/bh-storrelse-95a",
    "100A": "/collections/bh-storrelse-100a",
    "105A": "/collections/bh-storrelse-105a",
    "110A": "/collections/bh-storrelse-110a",
    "115A": "/collections/bh-storrelse-115a",
    "65B": "/collections/bh-storrelse-65b",
    "70B": "/collections/bh-storrelse-70b",
    "75B": "/collections/bh-storrelse-75b",
    "80B": "/collections/bh-storrelse-80b",
    "85B": "/collections/bh-storrelse-85b",
    "90B": "/collections/bh-storrelse-90b",
    "95B": "/collections/bh-storrelse-95b",
    "100B": "/collections/bh-storrelse-100b",
    "105B": "/collections/bh-storrelse-105b",
    "110B": "/collections/bh-storrelse-110b",
    "115B": "/collections/bh-storrelse-115b",
    "65C": "/collections/bh-storrelse-65c",
    "70C": "/collections/bh-storrelse-70c",
    "75C": "/collections/bh-storrelse-75c",
    "80C": "/collections/bh-storrelse-80c",
    "85C": "/collections/bh-storrelse-85c",
    "90C": "/collections/bh-storrelse-90c",
    "95C": "/collections/bh-storrelse-95c",
    "100C": "/collections/bh-storrelse-100c",
    "105C": "/collections/bh-storrelse-105c",
    "110C": "/collections/bh-storrelse-110c",
    "115C": "/collections/bh-storrelse-115c",
    "65D": "/collections/bh-storrelse-65d",
    "70D": "/collections/bh-storrelse-70d",
    "75D": "/collections/bh-storrelse-75d",
    "80D": "/collections/bh-storrelse-80d",
    "85D": "/collections/bh-storrelse-85d",
    "90D": "/collections/bh-storrelse-90d",
    "95D": "/collections/bh-storrelse-95d",
    "100D": "/collections/bh-storrelse-100d",
    "105D": "/collections/bh-storrelse-105d",
    "110D": "/collections/bh-storrelse-110d",
    "115D": "/collections/bh-storrelse-115d",
    "65E": "/collections/bh-storrelse-65e",
    "70E": "/collections/bh-storrelse-70e",
    "75E": "/collections/bh-storrelse-75e",
    "80E": "/collections/bh-storrelse-80e",
    "85E": "/collections/bh-storrelse-85e",
    "90E": "/collections/bh-storrelse-90e",
    "95E": "/collections/bh-storrelse-95e",
    "100E": "/collections/bh-storrelse-100e",
    "105E": "/collections/bh-storrelse-105e",
    "110E": "/collections/bh-storrelse-110e",
    "115E": "/collections/bh-storrelse-115e",
    "65F": "/collections/bh-storrelse-65f",
    "70F": "/collections/bh-storrelse-70f",
    "75F": "/collections/bh-storrelse-75f",
    "80F": "/collections/bh-storrelse-80f",
    "85F": "/collections/bh-storrelse-85f",
    "90F": "/collections/bh-storrelse-90f",
    "95F": "/collections/bh-storrelse-95f",
    "100F": "/collections/bh-storrelse-100f",
    "105F": "/collections/bh-storrelse-105f",
    "110F": "/collections/bh-storrelse-110f",
    "115F": "/collections/bh-storrelse-115f",
    "65G": "/collections/bh-storrelse-65g",
    "70G": "/collections/bh-storrelse-70g",
    "75G": "/collections/bh-storrelse-75g",
    "80G": "/collections/bh-storrelse-80g",
    "85G": "/collections/bh-storrelse-85g",
    "90G": "/collections/bh-storrelse-90g",
    "95G": "/collections/bh-storrelse-95g",
    "100G": "/collections/bh-storrelse-100g",
    "105G": "/collections/bh-storrelse-105g",
    "110G": "/collections/bh-storrelse-110g",
    "115G": "/collections/bh-storrelse-115g",
    "65H": "/collections/bh-storrelse-65h",
    "70H": "/collections/bh-storrelse-70h",
    "75H": "/collections/bh-storrelse-75h",
    "80H": "/collections/bh-storrelse-80h",
    "85H": "/collections/bh-storrelse-85h",
    "90H": "/collections/bh-storrelse-90h",
    "95H": "/collections/bh-storrelse-95h",
    "100H": "/collections/bh-storrelse-100h",
    "105H": "/collections/bh-storrelse-105h",
    "110H": "/collections/bh-storrelse-110h",
    "115H": "/collections/bh-storrelse-115h",
    "65I": "/collections/bh-storrelse-65i",
    "70I": "/collections/bh-storrelse-70i",
    "75I": "/collections/bh-storrelse-75i",
    "80I": "/collections/bh-storrelse-80i",
    "85I": "/collections/bh-storrelse-85i",
    "90I": "/collections/bh-storrelse-90i",
    "95I": "/collections/bh-storrelse-95i",
    "100I": "/collections/bh-storrelse-100i",
    "105I": "/collections/bh-storrelse-105i",
    "110I": "/collections/bh-storrelse-110i",
    "115I": "/collections/bh-storrelse-115i",
    "65J": "/collections/bh-storrelse-65j",
    "70J": "/collections/bh-storrelse-70j",
    "75J": "/collections/bh-storrelse-75j",
    "80J": "/collections/bh-storrelse-80j",
    "85J": "/collections/bh-storrelse-85j",
    "90J": "/collections/bh-storrelse-90j",
    "95J": "/collections/bh-storrelse-95j",
    "100J": "/collections/bh-storrelse-100j",
    "105J": "/collections/bh-storrelse-105j",
    "110J": "/collections/bh-storrelse-110j",
    "115J": "/collections/bh-storrelse-115j"
};